/*
 * BiChart
 * Clase basada en la libreria recharts (http://recharts.org)
 * <BiChart type="bar.vertical" data={data} colors={colors} Xunit="" Yunit="" />;
 * type= String [pie, pie.alt, bar, bar.stacked, bar.vertical, line]
 * data= Array input data
 * colors= Object one key per color/column

    const data = [
      {name: 'Page A', uv: 4000, pv: 2400, amt: 2400},
      {name: 'Page B', uv: 3000, pv: 1398, amt: 2210},
      {name: 'Page C', uv: 2000, pv: 9800, amt: 2290},
      {name: 'Page D', uv: 2780, pv: 3908, amt: 2000},
      {name: 'Page E', uv: 1890, pv: 4800, amt: 2181},
      {name: 'Page F', uv: 2390, pv: 3800, amt: 2500},
      {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
    ];
    const colors = {
      uv: '#FFBB28',
      pv: '#6600ff',
      amt: '#0088FE'
    }
    return <BiChart type="bar.vertical" data={data} colors={colors} />;
 */

//import { has, sortBy, orderBy } from "lodash";
import React, { Component } from "react";
// imports para grafico de utilidades, linas, barras, torta
import {
	ComposedChart,
	Tooltip,
	Legend,
	XAxis,
	YAxis,
	CartesianGrid
} from "recharts";
import { LineChart, Line } from "recharts"; // grafico lineas
import { BarChart, Bar, ReferenceLine } from "recharts"; // grafico barras
import { PieChart, Pie, Sector, Cell, text, circle, path } from "recharts"; // grafico torta
import { AreaChart, Area } from "recharts"; //grafico area

/*
 * Funciones auxiliares para el grafico de torta
 */
const RADIAN = Math.PI / 180;
const DEFAULT_CHART_WIDTH = 500;
const DEFAULT_CHART_HEIGHT = 250;
const renderPieChartLabel = ({
	cx,
	cy,
	midAngle,
	innerRadius,
	outerRadius,
	percent,
	index
}) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text
			x={x}
			y={y}
			fill="white"
			textAnchor={x > cx ? "start" : "end"}
			dominantBaseline="central"
		>
			{`${(percent * 100).toFixed(0)}%`}
		</text>
	);
};
const renderPieChartAltLabel = props => {
	// component data
	const {
		cx,
		cy,
		midAngle,
		innerRadius,
		outerRadius,
		startAngle,
		endAngle,
		fill,
		payload,
		percent,
		value
	} = props;
	const sin = Math.sin(-RADIAN * midAngle);
	const cos = Math.cos(-RADIAN * midAngle);
	const sx = cx + (outerRadius + 10) * cos;
	const sy = cy + (outerRadius + 10) * sin;
	const mx = cx + (outerRadius + 30) * cos;
	const my = cy + (outerRadius + 30) * sin;
	const ex = mx + (cos >= 0 ? 1 : -1) * 22;
	const ey = my;
	const textAnchor = cos >= 0 ? "start" : "end";

	return (
		<g>
			<text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
				{payload.name}
			</text>
			<Sector
				cx={cx}
				cy={cy}
				innerRadius={innerRadius}
				outerRadius={outerRadius}
				startAngle={startAngle}
				endAngle={endAngle}
				fill={fill}
			/>
			<Sector
				cx={cx}
				cy={cy}
				startAngle={startAngle}
				endAngle={endAngle}
				innerRadius={outerRadius + 6}
				outerRadius={outerRadius + 10}
				fill={fill}
			/>
			<path
				d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
				stroke={fill}
				fill="none"
			/>
			<circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
			<text
				x={ex + (cos >= 0 ? 1 : -1) * 12}
				y={ey}
				textAnchor={textAnchor}
				fill="#333"
			>{`Total ${value}`}</text>
			<text
				x={ex + (cos >= 0 ? 1 : -1) * 12}
				y={ey}
				dy={18}
				textAnchor={textAnchor}
				fill="#999"
			>
				{`${(percent * 100).toFixed(2)}%`}
			</text>
		</g>
	);
};

class BiChart extends Component {
	constructor(props) {
		super(props);
		this.state = {
			width: DEFAULT_CHART_WIDTH,
			height: DEFAULT_CHART_HEIGHT,
			data: [],
			colors: {},
			Xunit: "",
			Yunit: "",
			YAxisWidth: 60,
			YAxisInterval: "preserveEnd",
			type: "line",
			activeIndex: 0
		};
		this.onPieEnter = this.onPieEnter.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		const {
			width = DEFAULT_CHART_WIDTH,
			height = DEFAULT_CHART_HEIGHT,
			data = [],
			colors = {},
			type = "line",
			Xunit = "",
			Yunit = "",
			YAxisWidth = 60,
			YAxisInterval = "preserveEnd",
			textBottom = ""
		} = nextProps;
		this.setState({
			width,
			height,
			data,
			colors,
			type,
			Xunit,
			Yunit,
			YAxisWidth,
			YAxisInterval,
			textBottom
		});
	}

	/*
   * Render chart functions
   */
	renderPieChart(data, color, config) {
		const { width, height } = config;
		let items = data.map((entry, index) => (
			<Cell key={index} fill={color[entry.name]} />
		));
		return (
			<PieChart width={width} height={height}>
				<Pie
					data={data}
					dataKey="value"
					cx="50%"
					cy="50%"
					outerRadius={80}
					fill="#8884d8"
					labelLine={false}
					label={renderPieChartLabel}
				>
					{items}
				</Pie>
				<Tooltip />
				<Legend />
			</PieChart>
		);
	}
	// Auxiliary function
	onPieEnter(data, index) {
		this.setState({ activeIndex: index });
	}
	renderPieChartAlt(data, color = {}, config = {}, textBottom) {
		const { width, height } = config;
		let items = data.map((entry, index) => (
			<Cell key={index} fill={color[entry.name]} />
		));
		return (
			<div>
				<PieChart width={width} height={height}>
					<Pie
						activeIndex={this.state.activeIndex}
						activeShape={renderPieChartAltLabel}
						data={data}
						dataKey="value"
						cx="50%"
						cy="50%"
						innerRadius={60}
						outerRadius={80}
						fill="#8884d8"
						onMouseEnter={this.onPieEnter}
					>
						{items}
					</Pie>
				</PieChart>
				{textBottom ? textBottom : null}
			</div>
		);
	}
	renderBarChart(data, color = {}, config = {}) {
		const { width, height, Xunit, Yunit, YAxisWidth, YAxisInterval } = config;
		let array = Object.keys(color);
		let items = array.map((key, i) => (
			<Bar key={i} dataKey={key} fill={color[key]} />
		));
		return (
			<BarChart
				width={width}
				height={height}
				data={data}
				margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
			>
				<CartesianGrid strokeDasharray="3 3" />
				<XAxis unit={Xunit} dataKey="name" />
				<YAxis unit={Yunit} width={YAxisWidth} interval={YAxisInterval} />
				<Tooltip />
				<Legend />
				<ReferenceLine y={0} stroke="#000" />
				{items}
			</BarChart>
		);
	}
	renderBarChartStacked(data, color = {}, config = {}) {
		const { width, height, Xunit, Yunit, YAxisWidth, YAxisInterval } = config;
		let array = Object.keys(color);
		let items = array.map((key, i) => (
			<Bar key={i} dataKey={key} fill={color[key]} stackId="a" />
		));
		return (
			<BarChart
				width={width}
				height={height}
				data={data}
				stackOffset="sign"
				margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
			>
				<CartesianGrid strokeDasharray="3 3" />
				<XAxis unit={Xunit} dataKey="name" />
				<YAxis unit={Yunit} width={YAxisWidth} interval={YAxisInterval} />
				<Tooltip />
				<Legend />
				<ReferenceLine y={0} stroke="#000" />
				{items}
			</BarChart>
		);
	}
	renderBarChartVertical(data, color = {}, config = {}) {
		const { width, height, Xunit, Yunit, YAxisWidth, YAxisInterval } = config;
		let array = Object.keys(color);
		let items = array.map((key, i) => (
			<Bar key={i} dataKey={key} fill={color[key]} stackId="a" />
		));
		return (
			<ComposedChart
				layout="vertical"
				width={width}
				height={height}
				data={data}
				stackOffset="sign"
				margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
			>
				<XAxis unit={Xunit} type="number" />
				<YAxis
					unit={Yunit}
					width={YAxisWidth}
					interval={YAxisInterval}
					dataKey="name"
					type="category"
				/>
				<Tooltip />
				<Legend />
				{items}
			</ComposedChart>
		);
	}
	renderLineChart(data, color = {}, config = {}) {
		const { width, height, Xunit, Yunit, YAxisWidth, YAxisInterval } = config;
		let array = Object.keys(color);
		let items = array.map((key, i) => (
			<Line key={i} dataKey={key} stroke={color[key]} type="monotone" />
		));
		return (
			<LineChart
				width={width}
				height={height}
				data={data}
				margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
			>
				<XAxis unit={Xunit} dataKey="name" />
				<YAxis unit={Yunit} width={YAxisWidth} interval={YAxisInterval} />
				<CartesianGrid strokeDasharray="3 3" />
				<Tooltip />
				<Legend />
				{items}
			</LineChart>
		);
	}
	renderAreaChart(data, color = {}, config = {}) {
		const { width, height, Xunit, Yunit, YAxisWidth, YAxisInterval } = config;
		let array = Object.keys(color);
		let items = array.map((key, i) => (
			<Area
				key={i}
				dataKey={key}
				fill={color[key]}
				stroke={color[key]}
				stackId="1"
				type="monotone"
			/>
		));
		return (
			<AreaChart
				width={width}
				height={height}
				data={data}
				margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
			>
				<XAxis unit={Xunit} dataKey="name" />
				<YAxis unit={Yunit} width={YAxisWidth} interval={YAxisInterval} />
				<CartesianGrid strokeDasharray="3 3" />
				<Tooltip />
				<Legend />
				{items}
			</AreaChart>
		);
	}

	render() {
		const {
			width,
			height,
			data,
			colors,
			type,
			Xunit,
			Yunit,
			YAxisWidth,
			YAxisInterval,
			textBottom
		} = this.state;
		const config = { width, height, Xunit, Yunit, YAxisWidth, YAxisInterval };
		let html = null;
		switch (type) {
			case "pie":
				html = this.renderPieChart(data, colors, config);
				break;
			case "pie.alt":
				html = this.renderPieChartAlt(data, colors, config, textBottom);
				break;
			case "bar":
				html = this.renderBarChart(data, colors, config);
				break;
			case "bar.stacked":
				html = this.renderBarChartStacked(data, colors, config);
				break;
			case "bar.vertical":
				html = this.renderBarChartVertical(data, colors, config);
				break;
			case "area":
				html = this.renderAreaChart(data, colors, config);
				break;
			default:
			case "line":
				html = this.renderLineChart(data, colors, config);
		}
		return html;
	}
}

export default BiChart;



// WEBPACK FOOTER //
// ./src/components/BiChart/BiChart.js